export default function ({ store })
{
  if (typeof (window) != 'undefined')
  {
    window.fillTestData = () => store.dispatch('projectState/fillTestData');
  }
}
